import { isLandscape, isFullScreen } from './deviceReducer'

export const HIDE_UI_TIME = 3000

/*=============================================
 =              Action Constants              =
 =============================================*/

export const UPDATE_VIEWPORT_DIMENSIONS = 'Device.UPDATE_VIEWPORT_DIMENSIONS'
export const ORIENTATION_CHANGED = 'Device.ORIENTATION_CHANGED'
export const ORIENTATION_CHANGE_END = 'Device.ORIENTATION_CHANGE_END'
export const VIEW_CHANGE = 'Device.VIEW_CHANGE'
export const SET_GYROSCOPE_ENABLED = 'Device.SET_GYROSCOPE_ENABLED'

export const setGyroscopEnabled = enabled => ({
    type: SET_GYROSCOPE_ENABLED,
    enabled,
})

export const updateViewportDimensions = () => ({
    type: UPDATE_VIEWPORT_DIMENSIONS,
    isFullScreen: isFullScreen(),
})

export const orientationChanged = _ => ({
    type: ORIENTATION_CHANGED,
    orientation: isLandscape() ? 'Landscape' : 'Portrait',
})

// Orientation change end is fired by scream js in iOS only
export const orientationChangeEnd = ({
    orientation,
    isMinimalView,
    viewPortWidth,
    viewPortHeight,
    screenWidth,
    screenHeight,
    notchPadding,
}) => ({
    type: ORIENTATION_CHANGE_END,
    orientation,
    isMinimalView,
    viewportWidth: viewPortWidth,
    viewportHeight: viewPortHeight,
    screenWidth,
    screenHeight,
    notchPadding,
    isFullScreen: isFullScreen(),
})

export const viewChange = ({
    orientation,
    isMinimalView,
    viewPortWidth,
    viewPortHeight,
    screenWidth,
    screenHeight,
    notchPadding,
}) => ({
    type: VIEW_CHANGE,
    orientation,
    isMinimalView,
    viewPortWidth,
    viewPortHeight,
    screenWidth,
    screenHeight,
    notchPadding,
})
